module.exports = __webpack_public_path__ + "media/images/workgroups-7fc3bb129864b08bfeb0774ffbd3f720.svg";